import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking, success, pending, failed
  const [data, setData] = useState(null);
  const polledRef = useRef(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionId) {
      setStatus("failed");
      return;
    }

    let cancelled = false;
    const poll = async () => {
      polledRef.current += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        setData(r.data);
        if (r.data.payment_status === "paid") {
          setStatus("success");
          return;
        }
        if (r.data.status === "expired" || polledRef.current >= 8) {
          setStatus("failed");
          return;
        }
        setStatus("pending");
        setTimeout(poll, 2000);
      } catch {
        if (polledRef.current >= 5) {
          setStatus("failed");
        } else {
          setTimeout(poll, 2000);
        }
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  const view = {
    checking: { title: t.payment.checking, body: "" },
    pending: { title: t.payment.pendingTitle, body: t.payment.pendingBody },
    success: { title: t.payment.successTitle, body: t.payment.successBody },
    failed: { title: t.payment.failedTitle, body: t.payment.failedBody },
  }[status];

  return (
    <div data-testid="payment-page" className="py-32">
      <div className="container-prieure max-w-2xl text-center">
        <div className="illuminated-border bg-white py-16">
          <div className="font-display text-5xl mb-4" style={{
            color: status === "success" ? "var(--cinnabar)" : status === "failed" ? "var(--muted)" : "var(--gold)"
          }}>
            {status === "success" ? "✦" : status === "failed" ? "✕" : "…"}
          </div>
          <h1 data-testid="payment-status-title" className="font-display text-4xl mb-4">{view.title}</h1>
          {view.body && <p className="font-body text-lg" style={{ color: "var(--ink-2)" }}>{view.body}</p>}

          {data?.amount && status === "success" && (
            <p className="font-caps text-[0.78rem] mt-6" style={{ color: "var(--gold)" }}>
              {data.amount.toFixed(2)} € · {data.kind}
            </p>
          )}

          <div className="mt-10">
            <Link to="/" data-testid="payment-back-home" className="btn btn-outline">
              {t.payment.backHome}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
